/**
 * @desc 修改竞拍
 */
import { AuctionEntity, AuctionForm } from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type UpdateAuctionParameter = AuctionForm

const method = 'PUT'
const url = '/trade/member/auction/update'

export const updateAuctionApi = (
  data?: UpdateAuctionParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<AuctionEntity>({
    method,
    url,
    data,
    ...config
  })
}

updateAuctionApi.method = method
updateAuctionApi.url = url
